export { default } from './components/Heatmap'
